const state = {
    jobs: []
}

const getters = {
    jobs: state => state.jobs,
    getCount: state => state.jobs.length,
}

const actions = {
    async add({ commit }, { token, jobId }) {
        const data = {
            job_id: jobId,
            visitor_token: token
        };
        await axios.post('/ajax/visitor/considerations.json', data)
            .then(function (response) {
                commit('addJob', response.data.job);
            })
            .catch(response => console.log(response));
    },
    async remove({ commit }, { token, jobId }) {
        const params = { data: {
            job_id: jobId,
            visitor_token: token
        }};
        await axios.delete('/ajax/visitor/considerations.json', params)
            .then(function (response) {
                commit('setJobs', response.data.jobs);
            })
            .catch(response => console.log(response));
    },
    async get({ commit }, { token }) {
        await axios.get('/ajax/visitor/considerations.json', { params: { visitor_token: token }})
            .then(function (response) {
                commit('setJobs', response.data.jobs);
            })
            .catch(response => console.log(response));
    }
}

const mutations = {
    addJob(state,  job) {
        state.jobs.push(job.id);
    },
    setJobs(state,  jobs) {
        state.jobs = jobs;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
